@let controls = form().controls;
<form [class.compact]="compact()" [formGroup]="form()">
  <div class="address">
    <onyx-icon-box
      class="bar-icon location"
      color="white"
      [size]="20"
      [hasShadow]="true"
    >
      <onyx-icon name="location-filled" [size]="14"></onyx-icon>
    </onyx-icon-box>

    <onyx-address-input
      [formControl]="controls.address"
      label="labels.address"
      [size]="32"
      [showApartment]="true"
      apartmentWidth="calc({{ !compact() ? '4/12' : '1/3' }} * 100% - 12px)"
      [gap]="16"
      (nameChange)="setName($event)"
    ></onyx-address-input>
  </div>

  <onyx-text-field
    class="name"
    [formControl]="controls.name"
    [size]="32"
    label="labels.name"
  ></onyx-text-field>

  @let businessHoursControls = controls.businessHours.controls;
  <div class="opening-hours" [formGroup]="controls.businessHours">
    <onyx-icon-box
      class="bar-icon clock"
      color="white"
      [size]="20"
      [hasShadow]="true"
    >
      <onyx-icon name="clock-filled" [size]="14"></onyx-icon>
    </onyx-icon-box>

    <onyx-timepicker
      class="service-time"
      [formControl]="controls.serviceTime"
      [label]="serviceTimeLabel()"
      variant="duration"
      [size]="32"
    ></onyx-timepicker>

    <div class="toggle">
      <onyx-input-label
        [label]="'labels.openingHours' | translate"
      ></onyx-input-label>

      <onyx-toggle
        [(checked)]="isAlwaysOpen"
        label="24/7"
        [size]="32"
        [disabled]="disabled()"
      ></onyx-toggle>
    </div>

    @if (!isAlwaysOpen()) {
      <onyx-form-group
        class="opening-day"
        label="{{ 'labels.monday' | translate }} - {{
          'labels.friday' | translate
        }}"
        [controls]="businessHoursControls.weekday"
      >
        <onyx-timepicker
          [formControl]="businessHoursControls.weekday"
          [size]="32"
          [showTimeRange]="true"
          [showClockIcon]="false"
          [showErrors]="false"
        ></onyx-timepicker>

        <onyx-suggestions
          [control]="businessHoursControls.weekday"
          [suggestions]="TIME_RANGE_SUGGESTIONS"
        ></onyx-suggestions>
      </onyx-form-group>

      <div class="opening-day">
        <onyx-form-group label="labels.saturday">
          <onyx-timepicker
            [formControl]="businessHoursControls.saturday"
            [size]="32"
            [showTimeRange]="true"
            [showClockIcon]="false"
          ></onyx-timepicker>
        </onyx-form-group>

        <onyx-checkbox
          label="labels.closed"
          [(checked)]="isSaturdayClosed"
          [disabled]="disabled()"
        ></onyx-checkbox>
      </div>

      <div class="opening-day">
        <onyx-form-group label="labels.sunday">
          <onyx-timepicker
            [formControl]="businessHoursControls.sunday"
            [size]="32"
            [showTimeRange]="true"
            [showClockIcon]="false"
          ></onyx-timepicker>
        </onyx-form-group>

        <onyx-checkbox
          label="labels.closed"
          [(checked)]="isSundayClosed"
          [showRequired]="false"
          [disabled]="disabled()"
        ></onyx-checkbox>
      </div>
    }
  </div>

  <app-order-point-information-form
    [form]="form()"
    [compact]="compact()"
  ></app-order-point-information-form>
</form>
